import { GiftCardTransactionsFragment } from '@/gql/generated';
import { GapPrinterSdkContext } from '@/pages/(gapsdk)/_provider/gap-printer-sdk-provider';
import { ReactNode, useContext } from 'react';

const PrinterReceipt = (props: {
  children: ReactNode;
  className?: string;
  transaction?: GiftCardTransactionsFragment;
  onPrintDone?: () => void;
}) => {
  const { event: eventPrinter } = useContext(GapPrinterSdkContext);

  return (
    <div
      className={props.className}
      onClick={() => {
        if (props.transaction) {
          eventPrinter.onPrintReceiptByTransaction(props.transaction);
        }
        props.onPrintDone?.();
      }}
    >
      {props.children}
    </div>
  );
};

export default PrinterReceipt;
